export const getTitle = (text: string, step: number): string => (step === 21 ? "Encuesta Finalizada" : text);
